"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GKSearchableListFilter = void 0;
var __1 = require("../../../");
var React = __importStar(require("react"));
var GKSearchableListFilter = function (_a) {
    var _b = _a.column, filterValue = _b.filterValue, setFilter = _b.setFilter, preFilteredRows = _b.preFilteredRows, id = _b.id;
    // Our search value.
    var _c = React.useState(""), search = _c[0], setSearch = _c[1];
    // Build our list of options to display from the column data.
    // Reduces preFilteredRows to an array of this column's data,
    // wraps it in a Set to remove duplicates,
    // creates an array from the deduped Set,
    // and sorts it alphabetically.
    var itemsToFilter = React.useMemo(function () { return Array.from(new Set(preFilteredRows.map(function (r) { return r.values[id]; }))).sort(); }, [id, preFilteredRows]);
    // Handle an item being toggled.
    // Converts filterValue to a Set to simplify adding/removing items
    var toggleItem = function (item) {
        var selectedItems = new Set(filterValue);
        if (!selectedItems.delete(item)) {
            selectedItems.add(item);
        }
        setFilter(Array.from(selectedItems));
    };
    // Clear the selections and the search query
    var clearItems = function () {
        setSearch("");
        setFilter([]);
    };
    return (React.createElement(__1.GKMenuButton, { "data-qa": "gk-searchable-list-filter", icon: __1.GKIconName.Tune, closeOnSelect: false, containerClassName: " gk-searchable-list-filter ml-auto", color: (filterValue === null || filterValue === void 0 ? void 0 : filterValue.length) ? "primary" : undefined, size: "sm" },
        React.createElement(__1.GKMenuHeader, { className: "p-2" },
            React.createElement(__1.GKFormGroup, { className: "mb-1" },
                React.createElement(__1.GKLabel, null, "Filter by..."),
                React.createElement(__1.GKInputGroup, null,
                    React.createElement(__1.GKInputGroupAddon, { addonType: "prepend" },
                        React.createElement(__1.GKInputGroupText, null,
                            React.createElement(__1.GKIcon, { name: __1.GKIconName.Search }))),
                    React.createElement(__1.GKInput, { type: "text", value: search, onChange: function (e) { return setSearch(e.target.value); } }))),
            React.createElement(__1.GKButton, { color: "link", className: "pl-0", disabled: ((filterValue === null || filterValue === void 0 ? void 0 : filterValue.length) || 0) === 0, onClick: clearItems, size: "sm" }, "Clear Filters")),
        itemsToFilter
            .filter(function (o) {
            return o.toLocaleLowerCase().includes(search.toLocaleLowerCase());
        })
            .map(function (o) { return (React.createElement(__1.GKMenuItem, { key: o, active: filterValue === null || filterValue === void 0 ? void 0 : filterValue.includes(o), id: o + "-filter", onSelect: function () { return toggleItem(o); } },
            React.createElement(__1.GKCheckbox, { checked: (filterValue === null || filterValue === void 0 ? void 0 : filterValue.includes(o)) || false, className: "mb-0", readOnly: true, label: o, style: { pointerEvents: "none" } }))); })));
};
exports.GKSearchableListFilter = GKSearchableListFilter;
exports.default = exports.GKSearchableListFilter;
